import { List, Map } from 'immutable';
// Initial state is the place you define all initial values for the Redux store of the feature.
// In the 'standard' way, initialState is defined in reducers: http://redux.js.org/docs/basics/Reducers.html
// But when application grows, there will be multiple reducers files, it's not intuitive what data is managed by the whole store.
// So Rekit extracts the initial state definition into a separate module so that you can have
// a quick view about what data is used for the feature, at any time.

// NOTE: initialState constant is necessary so that Rekit could auto add initial state when creating async actions.

const initialState = {
  broadcastDetails: null,
  getBroadcastDetailsPending: false,
  getBroadcastDetailsError: null,
  getResendFailedBroadcastPending: false,
  getResendFailedBroadcastError: null,
  getIsResendFailedBroadcast: false,
  workingChannelInfo: null,
  workingWhatsappChannelInfo: null,
  sidebarFilterParams: {
    entitlementType: 'paid',
    isVip: 'all',
    emotionalScores: [],
    physicalScores: [],
    isMedical: 'all',
    sponsors: [],
    lastActive: 'all_time',
    lastCoachMessageAt: undefined,
    lastChattedWith: undefined,
    joinDate: 'all_time',
    firstLoginAt: 'all_time',
    channelType: undefined,
    isFollowUp: 'all',
    isUnreplied: 'all',
    nextPage: undefined,
    query: undefined,
    sortOrder: 'recent_to_oldest',
    language: 'all',
    country: 'all',
    healthGoal: 'all',
  },
  sidebarLeft: false,
  sidebarRight: false,
  toolbar: true,
  pageview: null,
  status: Map(),
  notification: Map(),
  pager: List(),
  users: [],
  newUsersChannels: [],
  recentlyReassignedUsersChannels: [],
  channels: [],
  timeHorizonLabel: null,
  userTabsTotal: List(),
  outerTabsTotal: List(),
  groupTabsTotal: List(),
  sponsors: [],
  sponsorTabs: null,
  filteredUserList: [],
  newUsers: [],
  groups: [],
  groupSponsors: [],
  sponsorTabsTotal: List(),
  recentlyReassignedUsers: [],
  broadcastListing: List(),
  broadcastModalShow: false,
  broadcastUsers: List(),
  currentBroadcast: {
    view: null,
    id: null,
  },
  userFromChannelId: null,
  sponsorsWithLogos: [],
  filterParams: {
    paid: true,
    to_reply: false,
    vip: false,
    sponsors: [],
  },
  searchResults: {
    users: [],
    channels: [],
    filteredUserList: [],
    pagination: null,
    newUsersPagination: null,
    recentlyReassignedUsersPagination: null,
    groupsPagination: null,
    usersNew: [],
    channelsNew: [],
    filteredUserListNew: [],
    paginationNew: null,
    usersToReply: [],
    channelsToReply: [],
    filteredUserListToReply: [],
    paginationToReply: null,
  },
  searchChannelResults: List(),
  sortedSearchResults: [],
  searchChannelsV2Pending: false,
  searchChannelsPending: false,
  searchChannelsError: null,
  searchChannelsV2Error: null,
  apiSentRequestTime: null,
  groupApiSentRequestTime: null,
  getChannelsError: null,
  getNotificationsPending: false,
  getNotificationsError: null,
  setToReplyPending: false,
  setToReplyError: null,
  resetNotificationsPending: false,
  resetNotificationsError: null,
  getChannelPending: false,
  getChannelError: null,
  getUserChannelPending: false,
  getUserChannelError: null,
  getBroadcastsPending: false,
  getBroadcastsError: null,
  getBroadcastUsersPending: false,
  getBroadcastUsersError: null,
  createBroadcastPending: false,
  createBroadcastError: null,
  deleteBroadcastPending: false,
  deleteBroadcastError: null,
  getChannelCountPending: false,
  getChannelCountError: null,
  getNewUsersPending: false,
  getNewUsersError: null,
  getRecentlyReassignedUsersPending: false,
  getRecentlyReassignedUsersError: null,
  getUserChannelCountPending: false,
  getUserChannelCountError: null,
  getGroupChannelCountPending: false,
  getGroupChannelCountError: null,
  getSponsorsListPending: false,
  getSponsorsListError: null,
  getUnsetUnreadMessagePending: false,
  getUnsetUnreadMessagePendingError: null,
  getUserFromChannelIdPending: false,
  getUserFromChannelIdError: null,
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/common/redux/initialState.js